module.exports = __webpack_public_path__ + "img/rain-pipe-active.d1153b50.png";